import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ title, value, icon, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-purple-100 dark:bg-purple-900/20',
    secondary: 'bg-blue-100 dark:bg-blue-900/20',
    success: 'bg-green-100 dark:bg-green-900/20',
    warning: 'bg-yellow-100 dark:bg-yellow-900/20'
  };

  const iconColorClasses = {
    primary: 'text-purple-600 dark:text-purple-400',
    secondary: 'text-blue-600 dark:text-blue-400',
    success: 'text-green-600 dark:text-green-400',
    warning: 'text-yellow-600 dark:text-yellow-400'
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2 transition-smooth hover:shadow-elevation-3">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl ${colorClasses?.[color]} flex items-center justify-center`}>
          <Icon name={icon} size={24} className={iconColorClasses?.[color]} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg ${trend === 'up' ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span className="text-xs font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-1 md:mb-2">{value}</h3>
      <p className="text-sm md:text-base text-muted-foreground">{title}</p>
    </div>
  );
};

export default StatCard;